
import React, { useState, useRef, useEffect } from "react";
import { Card, CardContain } from "../../style/Home";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    MenuItem,
    Menu,
    Button,
    FormControl,
    Select,
} from "@mui/material";
import EditNoteIcon from '@mui/icons-material/EditNote';
import { CommanTableContainDealerMaster } from "../../style/table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { DealerMasterModal, HierachyMasterModal } from "../../style/HO/MVRManualCreation";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { ContainerCustomDealerMaster, SmartSearchContain } from '../../style/table';
import { GuidelineContain } from "../../style/AM/MoMStatusUpdate"
import SearchIcon from "@mui/icons-material/Search";
import { GetEmployeeData, UpdateEmployee, GetUserRights, UpdateUserRights, ImportEmployeeExcel, GetExcelFile } from '../../services/employeeMaster'
import { IconButtonContain } from '../../style/HO/CreateManualCard'
import { ContainedButtton } from "../../style/HO/CreateManual";
import "react-toastify/dist/ReactToastify.css";
import { MeData } from "../../services/MeServices"
import Switch from '../../Components/Switch/Switch'
import excelFile from '../../../src/assets/templates/Employee_Templates.xlsx'

const EmployeeMaster = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [aiModalOpen, setAiModalOpen] = useState(false);
    const [userRightModalOpen, setUserRightModalOpen] = useState(false);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);
    const Drawer = useSelector((state) => state.drawer);
    const [search, setSearch] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [loader, setLoader] = useState(false)
    const [employeeData, setEmployeeData] = useState([])
    const [totalCount, setTotalCount] = useState(0);
    const [modalChange, setModalChange] = useState(false)
    const [csvFile, setCsvFile] = useState(null);
    const [userInformation, setUserInformation] = useState([]);
    const [userRights, setUserRights] = useState([])
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const excelInputRef = useRef(null);
    const empCodeRef = useRef(null);
    const [fileType, setFileType] = useState('');

    const handleDownloadFile = async (mimeType) => {
        try {
            const payload = {
                mimeType,
            };

            const response = await GetExcelFile({
                payload: payload,
            });

            if (response?.success && response?.url) {
                const link = document.createElement("a");
                link.href = response.url;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Download failed:", error);
            toast.error("Network Error");
        } finally {
            setFileType("");
        }
    };
    const handleFileTypeChange = async (event) => {
        const selectedType = event.target.value;
        setFileType(selectedType);

        if (selectedType) {
            await handleDownloadFile(selectedType);
        }
    };

    const mvrTableCols = [
        "EmployeeCode",
        "EmployeeName",
        "Role",
        "Contact No",
        "Email",
        "Address",
        "Status",
        "Edit",
    ];
    const getEmployeeData = async () => {
        try {
            setLoader(true)

            const payload = {
                search: debouncedSearchTerm,
                page: page,
                offset: rowsPerPage,
            }
            const res = await GetEmployeeData({ payload: payload })
            if (res.success) {
                setEmployeeData(res?.data?.employeesData);
                setTotalCount(res?.data?.totalDataCount);
            }
        } catch (error) {
            console.log("error", error)
            if (error.code === "ERR_NETWORK") {
                toast.error("Network error")
            }
        } finally {
            setLoader(false)
        }
    }


    const getMe = async () => {
        setLoader(true);
        console.log("getme");
        try {
            const res = await MeData()
            if (res.success) {
                setUserInformation(res.user);
                console.log(res.user);
            }
            else {
                console.log("bhbhbcbdhbc");
            }
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                toast.error("Network error")
            }
        }
    }


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    }

    const handleEditClick = (row) => {
        console.log(row);
        setSelectedRow(row);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedRow(null);
    };

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleUserRigthModalOpen = async (employeeCode) => {
        empCodeRef.current = employeeCode;
        setUserRightModalOpen(true);
        setLoader(true);
        try {
            const res = await GetUserRights({ empCode: employeeCode })
            if (res.success) {
                console.log(res.data);
                setUserRights(res.data);
            }
        }
        catch (error) {
            if (error.code === "ERR_NETWORK") {
                toast.error("Network error")
            }
        }
    }
    const handleUserRigthModalClose = () => setUserRightModalOpen(false)

    const fileInputRef = useRef();

    const handleUploadModalClose = () => {
        setUploadModalOpen(false);
    };

    const handleUpdatePreview = () => {
        setPreviewImage(selectedImage);
        setUploadModalOpen(false);
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(search);
        }, 600);

        return () => clearTimeout(handler);
    }, [search])

    useEffect(() => {
        getEmployeeData();
    }, [rowsPerPage, page, debouncedSearchTerm])

    useEffect(() => {
        getMe();
    }, [])

    const validateEmail = (email) => {
        const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return gmailRegex.test(email);
    };

    const validatePhone = (number) => {
        const phoneRegex = /^[6-9]\d{9}$/;
        return phoneRegex.test(number)
    }

    const handleSave = async (e) => {
        e.preventDefault();
        if (!validateEmail(selectedRow?.emailId)) {
            toast.error("Please enter a valid Email Id");
            return;
        }
        if (selectedRow?.phoneNumber && !validatePhone(selectedRow?.phoneNumber)) {
            toast.error("Please enter a valid phone number");
            return;
        }
        try {

            if (selectedRow.employeeName != "" && selectedRow.emailId != "" && selectedRow.role != "") {
                const payload = {
                    id: selectedRow?.id,
                    employeeName: selectedRow?.employeeName,
                    phoneNumber: selectedRow?.phoneNumber,
                    role: selectedRow?.role,
                    emailId: selectedRow?.emailId,
                    status: selectedRow?.status,
                    address: selectedRow?.address,
                }
                const res = await UpdateEmployee({ payload: payload })

                if (res.success) {
                    console.log(res);

                    setEmployeeData((prevData) =>
                        prevData.map((row) => {
                            return row.id === selectedRow.id
                                ? { ...row, ...payload }
                                : row
                        })
                    );
                    console.log(payload);
                    setModalOpen(false);
                    toast.success("Updated Successfully");
                }
            }
            else {
                toast.error("Please filled the required field");
            }
        }
        catch (error) {
            if (error.code === "ERR_BAD_REQUEST") {
                toast.error(error?.response?.data?.error);
            }
            else {
                toast.error("Connection failed");
            }
        }
    }


    const handleUpdateUserRight = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                empCode: empCodeRef.current,
                userRightNotice: userRights?.UserRightNotice,
                userRightNotifications: userRights?.UserRightNotifications,
                userRightCreateManual: userRights?.UserRightCreateManual,
                userRightEscalation: userRights?.UserRightEscalation,
                userRightEditDealerMaster: userRights?.UserRightEditDealerMaster,
                userRightEditEmployeeMaster: userRights?.UserRightEditEmployeeMaster,
                userRightEditHierarchyMaster: userRights?.UserRightEditHierarchyMaster,
                userRightViewDealerMaster: userRights?.UserRightViewDealerMaster,
                userRightViewEmployeeMaster: userRights?.UserRightViewEmployeeMaster,
                userRightViewHierarchyMaster: userRights?.UserRightViewHierarchyMaster,
            }

            const res = await UpdateUserRights({ payload: payload })
            if (res.success) {
                toast.success("UsersRights Update Successfully")
            }
        }
        catch (error) {
            toast.error("error");
        }
    }

    const handleExcelFile = async (event) => {

        const file = event.target.files[0];
        if (!file) {
            toast.error("Please select a file");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);

        try {
            const res = await ImportEmployeeExcel({ payload: formData })

            if (res.success) {
                toast.success("Excel File Upload Sucessfully");
                await getEmployeeData();
            }
        }
        catch (error) {
            if (error.code === "ERR_BAD_RESPONSE") {
                toast.error(error?.response?.data?.error);
            }
            else {
                toast.error(error?.response?.data?.error)
            }
        } finally {
            setTimeout(() => {
                setLoader(false);
            }, 1000)
        }
    };


    const roles = ["Head Office", "Regional Manager", "Zone Manager", "Area Manager"]

    return (
        <>
            <CardContain>
                <Card mt={2}>
                    <ContainerCustomDealerMaster>
                        <div className="import_btn">
                            <Button
                                variant="contained"
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                            >
                                Import
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                disableScrollLock
                            >
                                <a href={excelFile} download='EmployeeMaster.xlsx'>
                                    <MenuItem onClick={() => {
                                        handleClose();
                                    }}>Get Template</MenuItem>
                                </a>
                                <MenuItem
                                    onClick={() => {
                                        excelInputRef.current.value = "";
                                        excelInputRef.current.click();
                                        handleClose();
                                    }}
                                >
                                    Upload Excel
                                </MenuItem>
                            </Menu>
                        </div>

                        <div className="import_btn">
                            <SmartSearchContain >
                                <TextField
                                    label="Search"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    marginleft="auto"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <SearchIcon />
                            </SmartSearchContain>
                            <input
                                type="file"
                                style={{ display: "none" }}
                                ref={excelInputRef}
                                accept=".csv, .xls, .xlsx"
                                onChange={handleExcelFile}
                            />

                            <FormControl sx={{ minWidth: 70 }} size="small">
                                <Select
                                    className="download-select"
                                    value={fileType}
                                    onChange={handleFileTypeChange}
                                    displayEmpty
                                    disablePortal
                                    MenuProps={{
                                        disableScrollLock: true,
                                    }}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return "Download";
                                        }
                                        return "Download";
                                    }}
                                    //   disabled={isLoading || !selectedValue}

                                    sx={{
                                        cursor: "pointer",
                                        backgroundColor: "#009000",
                                        color: "white",
                                        borderRadius: "4px",

                                    }}
                                >
                                    <MenuItem value="csv" sx={{ cursor: "pointer" }}>
                                        Download CSV
                                    </MenuItem>
                                    <MenuItem value="xlsx" sx={{ cursor: "pointer" }}>
                                        Download Excel
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </div>


                    </ContainerCustomDealerMaster>
                    <GuidelineContain>
                        <div className="Guidelines">
                            <p>
                                <span>Guidelines : </span>
                                Only new employees should be added with upload excel.
                            </p>
                        </div>
                    </GuidelineContain>
                    <CommanTableContainDealerMaster>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {mvrTableCols.map((text, index) => (
                                        <TableCell key={index}>{text}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {employeeData?.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.employeeCode}</TableCell>
                                        <TableCell>{row.employeeName}</TableCell>
                                        <TableCell>{row.role}</TableCell>
                                        <TableCell>{row.phoneNumber}</TableCell>
                                        <TableCell style={{ textTransform: 'lowercase' }}>{row.emailId}</TableCell>
                                        <TableCell>{row.address}</TableCell>
                                        <TableCell>{row.status}</TableCell>

                                        <TableCell style={{ justifyContent: 'space-around' }}>
                                            <IconButtonContain className="icon_btn_n">
                                                {row?.canEditEmployeeInfo && (
                                                    <EditNoteIcon onClick={() => handleEditClick(row)} />
                                                )}
                                                {row?.canEditEmployeeUserRights && (
                                                    <VerifiedUserIcon onClick={() => handleUserRigthModalOpen(row.employeeCode)} />
                                                )}
                                            </IconButtonContain>
                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        </Table>
                    </CommanTableContainDealerMaster>
                </Card>
            </CardContain>
            <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            {modalOpen && (
                <HierachyMasterModal className={Drawer ? "" : "DrawerOpen"}>
                    <div className="modal_container_box">
                        <div className="ModalHeader">
                            <h4>Update Data</h4>
                            <button className="CloseButton" onClick={handleModalClose}>
                                <CloseIcon />
                            </button>
                        </div>
                        <div className="ModalBody">
                            <div className="input_form_group">
                                <label htmlFor="">Employee Code</label>
                                <input value={selectedRow?.employeeCode || ""} disabled />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Employee Name</label>
                                <input value={selectedRow?.employeeName || ""} onChange={(e) => { setSelectedRow({ ...selectedRow, employeeName: e.target.value }) }} required />
                            </div>

                            <div className="input_form_group">
                                <label htmlFor="status">Role</label>
                                <select
                                    id="role"
                                    value={selectedRow?.role}
                                    onChange={(e) => setSelectedRow({ ...selectedRow, role: e.target.value })}
                                >
                                    {roles.map(elem => (<option value={elem} hidden={elem === selectedRow?.role} >{elem}</option>))}
                                </select>

                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Contact No.</label>
                                <input value={selectedRow?.phoneNumber || ""}
                                    onChange={(e) => {
                                        setSelectedRow({ ...selectedRow, phoneNumber: e.target.value })
                                        validatePhone(e.target.value)
                                    }}
                                />
                            </div>
                            <div className="input_form_group" >
                                <label htmlFor="">Email ID</label>
                                <input value={selectedRow?.emailId || ""}
                                    onChange={(e) => {
                                        setSelectedRow({ ...selectedRow, emailId: e.target.value })
                                        validateEmail(e.target.value);
                                    }}
                                    required />
                            </div>

                            <div className="input_form_group">
                                <label htmlFor="status">Status</label>
                                <select
                                    id="status"

                                    value={selectedRow?.status} // Ensure the selected value reflects the current state
                                    onChange={(e) => setSelectedRow({ ...selectedRow, status: e.target.value })}
                                // Update the status in state
                                >
                                    {selectedRow?.status === "Active" ? (
                                        <>
                                            <option value="Active" hidden={selectedRow?.status === "Active"}>Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </>
                                    ) : (
                                        <>
                                            <option value="Inactive" hidden={selectedRow?.status === "Inactive"}>Inactive</option>
                                            <option value="Active" >Active</option>
                                        </>
                                    )}

                                </select>

                            </div>



                            <div className="input_form_group">
                                <label htmlFor="">Address</label>
                                <textarea value={selectedRow?.address || ""} onChange={(e) => setSelectedRow({ ...selectedRow, address: e.target.value })} />
                            </div>

                        </div>
                        <div className="">
                            <div
                                className="input_form_group modal_btn_group"
                                style={{ display: 'flex', justifyContent: 'flex-end' }} // Align button to the right
                            >
                                <ContainedButtton
                                    variant="contained"
                                    onClick={(e) => handleSave(e)}
                                    className="save_btn"
                                    style={{ margin: "7px" }}
                                >
                                    Update
                                </ContainedButtton>
                            </div>
                        </div>

                    </div>
                </HierachyMasterModal>
            )}



            {userRightModalOpen && (
                <DealerMasterModal className={Drawer ? "" : "DrawerOpen"}>
                    <div className="modal_container_box">
                        <div className="ModalHeader">
                            <h4>User Rights</h4>
                            <button className="CloseButton" onClick={handleUserRigthModalClose}>
                                <CloseIcon />
                            </button>
                        </div>
                        <div className="ModalBody">
                            <div className="password_input_form">

                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor=""> Create Manual </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightCreateManual: bool })}
                                            checked={userRights?.UserRightCreateManual}
                                        />
                                    </span>
                                </div>

                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">View Dealer Master </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightViewDealerMaster: bool })}
                                            checked={userRights?.UserRightViewDealerMaster}
                                        />
                                    </span>
                                </div>
                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">View Employee Master </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightViewEmployeeMaster: bool })}
                                            checked={userRights?.UserRightViewEmployeeMaster}
                                        />
                                    </span>
                                </div>
                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">View Hierarchy Master </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightViewHierarchyMaster: bool })}
                                            checked={userRights?.UserRightViewHierarchyMaster}
                                        />
                                    </span>
                                </div>
                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">Edit Dealer Master </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightEditDealerMaster: bool })}
                                            checked={userRights?.UserRightEditDealerMaster}
                                        />
                                    </span>
                                </div>

                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">Edit Employee Master </label>
                                    <span><Switch onChange={bool => setUserRights({ ...userRights, UserRightEditEmployeeMaster: bool })
                                    }
                                        checked={userRights?.UserRightEditEmployeeMaster} /></span>
                                </div>
                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">Edit Hierarchy Master </label>
                                    <span>
                                        <Switch onChange={bool =>
                                            setUserRights({ ...userRights, UserRightEditHierarchyMaster: bool })
                                        }
                                            checked={userRights?.UserRightEditHierarchyMaster} /></span>
                                </div>
                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">Escalations </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightEscalation: bool })}
                                            checked={userRights?.UserRightEscalation}
                                        />
                                    </span>
                                </div>
                                <div className="input_form_group form_toggle_btn">
                                    <label htmlFor="">Notice(Gallery) </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightNotice: bool })}
                                            checked={userRights?.UserRightNotice}
                                        />
                                    </span>
                                </div>
                                <div className="input_form_group  form_toggle_btn">
                                    <label htmlFor="">Notification </label>
                                    <span>
                                        <Switch
                                            onChange={bool => setUserRights({ ...userRights, UserRightNotifications: bool })}
                                            checked={userRights?.UserRightNotifications}
                                        />
                                    </span>
                                </div>

                            </div>
                        </div>
                        <div className="">
                            <div
                                className="input_form_group modal_btn_group"
                                style={{ display: 'flex', justifyContent: 'flex-end' }}
                            >
                                <ContainedButtton
                                    variant="contained"
                                    onClick={(e) => handleUpdateUserRight(e)}
                                    className="save_btn"
                                    style={{ margin: "7px" }}
                                >
                                    Update
                                </ContainedButtton>
                            </div>
                        </div>
                    </div>
                </DealerMasterModal>
            )}

            {uploadModalOpen && (
                <DealerMasterModal className={Drawer ? "" : "DrawerOpen"}>
                    <div className="modal_container_box">
                        <div className="ModalHeader">
                            <h4>Preview Image</h4>
                            <button className="CloseButton" onClick={handleUploadModalClose}>
                                <CloseIcon />
                            </button>
                        </div>
                        <div className="ModalBody">
                            {selectedImage && (
                                <img
                                    src={selectedImage}
                                    alt="Selected"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        marginTop: "10px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                    }}
                                />
                            )}
                        </div>
                        <div className="ModalFooter_1">
                            <div className="input_form_group modal_btn_group">
                                <button className="cancel_btn" onClick={handleUploadModalClose}>
                                    Cancel
                                </button>
                                <button
                                    className="update_btn"
                                    onClick={handleUpdatePreview}
                                    disabled={!selectedImage}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </DealerMasterModal>
            )}

            <ToastContainer />
        </>
    );
};

export default EmployeeMaster;
